import { render, staticRenderFns } from "./AdminUpdateForm.vue?vue&type=template&id=10573122"
import script from "./AdminUpdateForm.vue?vue&type=script&lang=js"
export * from "./AdminUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports